export type HederaGasEstimate = {
  gasLimit: number
  estimatedCostHbar: string
}

export type HederaOperationType = 'approveHash' | 'execTransaction' | 'createSafe'

const estimates: Record<HederaOperationType, HederaGasEstimate> = {
  approveHash: {
    gasLimit: 70_000,
    estimatedCostHbar: '0.06',
  },
  execTransaction: {
    gasLimit: 1_125_000,
    estimatedCostHbar: '0.90',
  },
  createSafe: {
    gasLimit: 750_000,
    estimatedCostHbar: '0.60',
  },
}

export default estimates
